import React from "react";
import { Create, useAuthenticated } from "react-admin";
import { useNotification } from "../../../common/hooks/useNotification";
import { EditActions } from "../../common/form/FormActions";
import { FmcsaDataTransferForm } from "./FmcsaDataTransferForm";

export const CreateFmcsaDataTransfer = () => {
  useAuthenticated();
  const props = {
    hasList: false,
    hasEdit: false,
    hasShow: false,
    resource: "fmcsa-data-transfer",
    basePath: "/hos-fmcsa-data-transfer",
    undoable: false,
  };

  const notify = useNotification(props, "createSuccess");
  return (
    <Create
      {...props}
      actions={<EditActions />}
      title="resources.fmcsa-data-transfer.title"
      onSuccess={notify}
    >
      <FmcsaDataTransferForm />
    </Create>
  );
};
